import RuleActionModel from '@/common/models/rules/actions/rule-action-model';
import EventTypes from '@/common/api/definitions/event-types';

export default class ReminderActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        ({role: this.role = ReminderActionModel.Roles.all} = fields);
    }

    getPayload() {
        return {
            ...super.getPayload(),
            role: this.role,
        };
    }

    static Roles = {
        all: 'all',
        trialEnd: 'trial-end',
        renewal: 'renewal',
    };

    static SupportedEventGroups = {
        subscription: 'subscription',
        invoice: 'invoice',
        paymentCard: 'paymentCard',
    };

    static ReminderEvents = [
        EventTypes.subscriptionTrialEndReminder,
        EventTypes.subscriptionRenewalReminder,
        EventTypes.invoicePastDueReminder,
        EventTypes.paymentCardExpirationReminder,
    ];

    static SupportedEvents = {
        subscription: [
            EventTypes.subscriptionActivated,
            EventTypes.subscriptionRenewed,
            EventTypes.subscriptionTrialEnded,
            EventTypes.subscriptionTrialEndReminder,
            EventTypes.subscriptionRenewalReminder,
            EventTypes.subscriptionTrialConverted,
        ],
        invoice: [
            EventTypes.invoiceIssued,
            EventTypes.invoicePastDue,
            EventTypes.invoicePastDueReminder,
        ],
        paymentCard: [
            EventTypes.paymentCardCreated,
            EventTypes.paymentCardExpirationReminder,
        ],
    };
}
